const tooltipContent = {
  fox: 'partners-widgets.advertiser-disclaimer.fox',
  fox1: 'partners-widgets.advertiser-disclaimer.fox',
}

const tooltipContentSubject = {
  fox: 'Fox Advertising Disclosure',
  fox1: 'Fox Advertising Disclosure',
}

export { tooltipContent, tooltipContentSubject }
